import { makeSelectors } from '@utils/css';

const modifiers = makeSelectors({
  active: "diba1br8h6j"
});
const radio = "dibrhx2htb";

export { modifiers, radio };
import "./radio.style.linaria.module.css";
//# sourceMappingURL=radio.style.js.map
